// src/lib/pairingClient.js
// Filepath: // src/lib/pairingClient.js
import { auth, db, functions } from "../firebase";
import { signInAnonymously, signInWithCustomToken } from "firebase/auth";
import { doc, setDoc, onSnapshot, serverTimestamp } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { generateCode } from "./pairingCode";
import { sha256Hex } from "./pairingCrypto";

const COL = "devicePairingSessions";

export async function ensureAnon() {
  if (!auth.currentUser) await signInAnonymously(auth);
  return auth.currentUser;
}

export async function createTvSession({ appVersion, model }) {
  const user = await ensureAnon();
  const sessionId = crypto.randomUUID();
  const code = generateCode(6);        // 6-char, uppercase letters+numbers
  const secret = crypto.randomUUID();
  const secretHash = await sha256Hex(secret);

  const now = new Date();
  const expiresAt = new Date(now.getTime() + 10 * 60 * 1000);

  await setDoc(doc(db, COL, sessionId), {
    code,                             // display (UPPER)
    codeLower: code.toLowerCase(),    // lookup
    ownerUid: user.uid,
    secretHash,
    status: "pending",
    userUid: null,
    createdAt: serverTimestamp(),
    expiresAt,
    tvInfo: { appVersion, model },
  });

  return { sessionId, code, secret };
}

export function watchApproval(sessionId, { onApproved, onExpired, onError }) {
  const unsub = onSnapshot(doc(db, COL, sessionId), snap => {
    if (!snap.exists()) return onExpired?.();
    const data = snap.data();
    if (data.status === "approved") onApproved?.(data);
    if (data.expiresAt?.toMillis && data.expiresAt.toMillis() <= Date.now()) onExpired?.();
  }, onError);
  return unsub;
}

export async function exchangeForToken(sessionId, secret) {
  const call = httpsCallable(functions, "exchangeForToken");
  const { data } = await call({ sessionId, secret, tvInfo: {} });
  await signInWithCustomToken(auth, data.customToken);
}
